import type { ToolResultItem } from '@elara/client-core/chat/tool-badges/types';

import type { IconName } from '#ui/MaterialIcon.js';

import { ToolResultRow } from './ToolResultRow.js';

/** Vertical list of result rows rendered inside an expanded badge. */
export function ToolResultLinkList({ items, itemIcon }: { items: ToolResultItem[]; itemIcon: IconName }) {
  return (
    <ul className="list-none p-1 m-0 bg-background rounded-md border text-sm max-h-[290px] overflow-y-auto">
      {items.map((item) => (
        <ToolResultRow key={item.key} item={item} itemIcon={itemIcon} />
      ))}
    </ul>
  );
}
